import { Grid } from '@mui/material'
import { useContext } from 'react'
import type { PhraseInfo } from '../interfaces/PhraseIf'
import { LanguageContext } from '../util/LanguageContext'
import { ItemButton } from './ItemButton'

type PhraseListProps = {
  items: PhraseInfo[]
  onDeletePhrase: (text: string) => void
}
export const PhraseList: React.FC<PhraseListProps> = props => {
  // 文字列変換用
  const translation = useContext(LanguageContext)
  return (
    <>
      {props.items.map(phrase => (
        <Grid item lg={6} xl={3.7}>
          <ItemButton
            title={translation['label_priority_words']}
            id={phrase.phrase_id}
            text={phrase.text!}
            onDel={props.onDeletePhrase.bind(null, phrase.text!)}
          />
        </Grid>
      ))}
    </>
  )
}
